import { isDefined } from '@/utils/isDefined';

export const safeString = (value: unknown) => {
  if (!isDefined(value)) {
    return value;
  }

  return String(value);
};
